var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vktimezone",class:{ m: _vm.$ctx.isMO() }},[_c('span',{staticClass:"tzname"},[_vm._v(_vm._s(_vm.tzName))]),_c('span',{staticClass:"timetick"},[_vm._v(_vm._s(_vm.timeTick.value))]),(!_vm.isMatchServerTime)?_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.res.serverTimeCheck))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }